import { CONST } from '../../const/const'
import FirestoreService from '../../services/firestoreService'
import { IEventActivityInterface } from './event-activity.interface'
import { EventActivityModel } from './event-activity.model'
import { where } from 'firebase/firestore'
import { getConvertedData } from '../interface.helper'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

/**
 * Get activities for an event with pagination
 * @param eventId ID of the event
 * @param limit Number of results to return
 * @param lastDoc Last document for pagination
 * @returns Object with activities array and the last document
 */
export const getEventActivities = async (
  eventId: string,
  limit = 20,
  lastDoc?: any
): Promise<{
  activities: IEventActivityInterface[]
  lastDoc: any
}> => {
  try {
    // Use FirestoreService to query Firestore
    const snapshot = await FirestoreService.filterItems(
      COLLECTIONS.EVENT_ACTIVITY.NAME,
      [where('eventId', '==', eventId)],
      limit,
      'activityTime',
      'desc',
      lastDoc ? lastDoc.id : undefined
    )

    const activities: IEventActivityInterface[] = []

    snapshot.forEach((curr) => {
      const activity = EventActivityModel.fromFirestoreDoc(curr)
      if (activity) {
        activities.push(getConvertedData(activity.toObject()))
      }
    })

    return {
      activities,
      lastDoc: snapshot.docs.length > 0 ? snapshot.docs[snapshot.docs.length - 1] : null,
    }
  } catch (error) {
    console.error('Error getting event activities:', error)
    throw error
  }
}
